import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, LoadingController } from '@ionic/angular';
import { StudioService } from '../services/studio.service';

@Component({
  selector: 'app-purchase-studio-result',
  templateUrl: './purchase-studio-result.component.html',
  styleUrls: ['./purchase-studio-result.component.scss'],
})
export class PurchaseStudioResultComponent implements OnInit {
  public plan: any = {}; 
  studioId: string;
  planId: string;
  studio: any = {};
  isLoading = false;
  private currentUser: any = null;
  public emailId: string;

  constructor(private router: Router, 
    private loadingCtrl: LoadingController,
    private studioService: StudioService, 
    private route: ActivatedRoute,
    private alertCtrl: AlertController) { 
    this.route.params.subscribe((params) => {
      if (params.id && params.planId) {
        this.studioId = params.id;
        this.planId = params.planId;
        this.showLoader();
        this.getStudioDetails();
      }
    });
    this.currentUser = JSON.parse(localStorage.getItem('pToken'));
    if (this.currentUser) {
        this.emailId = this.currentUser.user.email;
    }
  }

  ngOnInit() {}

  getStudioDetails(){
    this.studioService.getStudio(this.studioId, {}).subscribe(
      (response: any) => {
        this.hideLoader();
        this.studio = response.result;
        let planId = this.planId;
        this.plan = this.studio.term_prices.filter(function(plan){
          return parseInt(plan.id) === parseInt(planId);
        })[0];
      });
  }

  async openTooltip(event) {
    event.stopPropagation();
    const alert = await this.alertCtrl.create({
      message: 'Subject to availability.',
      buttons: ['OK']
    });
    await alert.present();
  }

  showLoader() {
    this.isLoading = true;
    this.loadingCtrl
      .create({
        message: 'Loading...',
      })
      .then((res) => {
        res.present().then(()=>{
          //To avoid loader overlapping
          if (!this.isLoading) {
            res.dismiss().then(() => {});
          }      
        });

        res.onDidDismiss().then((dis) => {});
      });
  }
  hideLoader() {
    this.isLoading = false;
    this.loadingCtrl.dismiss();
  }

}
